export const GET_CLIENT_SO_CART_ENDPOINT = '/OsimCart/GetClientSOCart';
